export const getAuthUser = () => {
  try {
    return JSON.parse(localStorage.getItem("authUser") || "{}");
  } catch {
    return {};
  }
};

export const getUserId = () => getAuthUser().id;
export const getUserEmail = () => getAuthUser().email;
export const getUserName = () => getAuthUser().fullName;
export const getUserRole = () => getAuthUser().role;
export const isAdmin = () => {
  const role = getUserRole()?.toUpperCase();
  return role === "ADMIN" || role === "SUPER_ADMIN";
};
